<!--
 * @Description:
 * @Author: xgx
 * @Date: 2022-10-13 09:57:02
 * @LastEditors: xgx
-->
<template>
  <div id="box" class="box">
    <div id="left" class="left">
      <div style="font-weight: 600" class="title">组织架构</div>
      <div class="search">
        <a-input-search
            v-model="organizationName"
            placeholder="搜索组织架构名称"
            size="large"
            @search="search"
        >
          <template #enterButton @click="search">
            <img class="img" src="@/assets/images/search.jpg" />
          </template>
        </a-input-search>
      </div>
      <div @click="expandHandle">
        <div v-if="expandAll">
          <img class="close-img" src="@/assets/images/close.jpg" /><span
            class="close-name"
        >全部收缩</span
        >
        </div>
        <div v-if="!expandAll">
          <img class="close-img" src="@/assets/images/open.jpg" /><span
            class="close-name"
        >全部展开</span
        >
        </div>
      </div>
      <a-spin :spinning="isTree">
        <div class="tree-box tree-container el-tree">
          <el-tree
              :data="treeData"
              ref="tree"
              node-key="id"
              :expand-on-click-node="false"
              :current-node-key="organization"
              :style="{
              height: heightLeft,
              overflowY: 'auto',
              overflowX: 'hidden',
            }"
              :default-expanded-keys="defaultShowNodes"
              class="tree"
              icon-class="icon-tree"
              @node-click="onSelect"
          >
          </el-tree>
        </div>
      </a-spin>
    </div>
    <div id="resize"></div>
    <div id="right" class="right">
      <div style="font-weight: 600" class="right-name">
        评分清单
      </div>
      <div v-if="type == 1">
        <div class="top">
          <div style="display: flex;align-items: center;margin-bottom: 20px">
            <el-button
                type="primary"
                plain
                @click="openRules"
            >绩效规则</el-button>
            <div class="fraction">
              <p>登录得分 <span>{{ countNum.loginMark||0 }}</span></p>
              <p>发稿得分 <span>{{ countNum.reportsMark||0 }}</span></p>
              <p>采纳得分 <span>{{ countNum.adoptMark||0 }}</span></p>
            </div>
          </div>
          <div class="search">
            <el-date-picker
                v-model="dateValue"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                @change="dateChange"
                value-format="yyyy-MM-dd"
                :clearable="false"
                :picker-options="pickerOptions"
                end-placeholder="结束日期">
            </el-date-picker>
            <el-button style="margin-left: 10px" v-if="!isShowBtn" type="primary" @click="searchTwo"
            >查询</el-button
            >
          </div>
        </div>
        <coententTable
            :y="height"
            @handleTableChange="handleTableChange"
            @onShowSizeChange="onShowSizeChange"
            :columns="type == 1 ? columns : columnsTwo"
            :dataSource="dataSource"
            :customSlot="customSlot"
            :loading="loading"
        >
        </coententTable>
        <div id="pagination" class="pagination">
          <div class="switch">
            <a-switch v-model="switchOpen" @change="onChange" />
            <span class="cy-txt">仅展示直属成员</span>
          </div>
          <a-pagination
              :current="pagination.current"
              :pageSize="pagination.pageSize"
              show-size-changer
              :pager-count="5"
              show-quick-jumper
              :total="pagination.total"
              @change="onShowSizeChange"
              @showSizeChange="handleTableChange"
              :page-size-options="pagination.pageSizeOptions"
              :show-total="(total) => `共 ${pagination.total} 条`"
          />
        </div>
      </div>
    </div>
    <PerformanceRules v-if="dialogVisible" @handleClose="handleClose" :dialogVisible="dialogVisible"></PerformanceRules>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import PerformanceRules from "./performance_rules.vue";
import {
  organTree,
  list,
  deleteOne,
  deleteFn,
  selectSiteListByOrgId, orgReportsCount,
} from "./performance";
import { message } from "ant-design-vue";
export default {
  data() {
    return {
      type: 1,
      height: 0,
      switchOpen: true,
      dateValue:["2023-10-01","2023-10-30"],
      visible: false,
      isShowBtn: false,
      deleteShow: false,
      visibleTwo: false,
      isBtnShow: false,
      itemTwo: false,
      isCloseAll: false,
      deleteShowTwo: false,
      heightLeft: 0,
      heightTwo: 0,
      selectValue: 1,
      value: "",
      expandedKeys: [],
      selectedKeys: [],
      addUserDataId: "",
      siteList: [],
      listData: [],
      deleteItem: {},
      itemAdd: {},
      item: {},
      roleIds: [],
      treeData: [],
      selectName: "管理员姓名",
      selectArr: [
        {
          label: "管理员姓名",
          value: "1",
        },
        {
          label: "手机号",
          value: "2",
        },
      ],
      defaultProps: {
        children: "children",
        label: "name",
      },
      organization: "",
      organizationName: "",
      organizationNameTwo: "",
      name: "",
      loading: false,
      role: undefined,
      columns: [
        {
          title: "管理员姓名",
          dataIndex: "name",
          ellipsis: true,
          width: 120,
        },
        {
          title: "管理员手机号",
          dataIndex: "phone",
          width: 150,
          ellipsis: true,
        },
        {
          title: "所属组织",
          dataIndex: "organizationName",
          width: 150,
        },
        {
          title: "登录天数",
          dataIndex: "loginDay",
          width: 90,
          ellipsis: true,
        },
        {
          title: "登录得分",
          dataIndex: "loginMark",
          width: 90,
          ellipsis: true,
        },
        {
          title: "发稿数",
          dataIndex: "reports",
          width: 90,
          ellipsis: true,
        },
        {
          title: "发稿得分",
          dataIndex: "reportsMark",
          width: 90,
          ellipsis: true,
        },
        {
          title: "被采纳稿件数",
          dataIndex: "adoptNum",
          width: 90,
          ellipsis: true,
        },
        {
          title: "报送得分",
          dataIndex: "adoptMark",
          width: 90,
          ellipsis: true,
        },
        {
          title: "总分",
          dataIndex: "countMark",
          width: 90,
          ellipsis: true,
        },
      ],
      customSlot: [
        {
          name: "name",
          customRender: "name",
        },
        {
          name: "state",
          customRender: "state",
        },
      ],
      columnsTwo: [
        {
          title: "微信公众号",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
          customCell: (column) => {
            return {
              style: {
                "min-width": "220px",
                "max-width": "400px",
              },
            };
          },
          customHeaderCell: (column) => {
            return {
              style: {
                "min-width": "220px",
                "max-width": "400px",
              },
            };
          },
        },
        {
          title: "状态",
          dataIndex: "state",
          width: 120,
          scopedSlots: { customRender: "state" },
        },
        {
          title: "授权人",
          dataIndex: "grantName",
          width: 120,
        },
        {
          title: "授权时间",
          dataIndex: "grantTime",
          width: 200,
        },
        {
          title: "权限刷新时间",
          dataIndex: "refreshTime",
          width: 200,
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
      },
      dataSource: [],
      cancelPreAuth: false,
      codeData: [],
      isTree: false,
      dialogVisibleTwo: false,
      expandAll: true,
      dialogVisibleOrg: false,
      orgItem: {},
      activeName: "first",
      defaultShowNodes: [],
      countNum:{
        loginMark:0,
        reportsMark:0,
        adoptMark:0
      },
      dialogVisible:false,
      pickerOptions:{
        disabledDate(time) {
          let date = new Date(time);
          let year = date.getFullYear();
          let month = date.getMonth()+1;
          let day = date.getDate();
          return year<2023||year<=2023&&month<10&&day>=1;
        }
      },
      formData:{
        orgId: null,
        startTime: "2023-10-01",
        endTime: "2023-10-30",
        childrenType: 1,
        current: 1,
        size: 10
      },
    };
  },
  components: {
    coententTable,
    PerformanceRules
  },
  mounted() {
    this.codeData = JSON.parse(sessionStorage.getItem("menuData"));
    this.heightLeft = `${document.documentElement.clientHeight - 285}px`;
    this.getOrganTree();
    let _this = this;
    this.$nextTick(() => {
      var left = document.getElementById("left");
      var box = document.getElementById("box");
      var right = document.getElementById("right");
      var pagination = document.getElementById("pagination");
      left.style.width = 348 + "px";
      right.style.width = box.clientWidth - 348 - 5 + "px";
      pagination.style.width = box.clientWidth - 348 + 5 + "px";
      if (box.clientWidth - 250 - 5 < 1000) {
        document.getElementsByClassName(
            "ant-pagination"
        )[0].style.marginRight = 0;
        document.getElementsByClassName(
            "ant-pagination-options"
        )[0].style.display = "none";
      } else {
        document.getElementsByClassName("ant-pagination")[0].style.marginRight =
            "124px";
        document.getElementsByClassName(
            "ant-pagination-options"
        )[0].style.display = "block";
      }
      if (box.clientWidth - 250 - 5 < 720) {
        _this.height = document.documentElement.clientHeight - 580
        _this.isShowBtn = true;
      } else {
        _this.isShowBtn = false;
      }
    });
    this.getLeftMove();
  },
  methods: {
    openRules(){
      this.dialogVisible = true;
    },
    handleClose(){
      this.dialogVisible = false;
    },
    dateChange(val){
      this.formData.startTime = val[0];
      this.formData.endTime = val[1];
    },
    handleClick() {
      if (this.activeName == "first") {
        this.type = 1;
        this.changeType(1);
      }
      if (this.activeName == "second") {
        this.type = 2;
        this.changeType(2);
      }
      if (this.activeName == "third") {
        this.type = 3;
        this.changeType(3);
      }
      if (this.activeName == "fourth") {
        this.type = 4;
        this.changeType(4);
      }
    },
    getLeftMove() {
      var resize = document.getElementById("resize");
      var left = document.getElementById("left");
      var right = document.getElementById("right");
      var box = document.getElementById("box");
      let _this = this;
      var pagination = document.getElementById("pagination");
      resize.onmousedown = function (e) {
        var startX = e.clientX;
        resize.left = resize.offsetLeft;
        document.onmousemove = function (e) {
          var endX = e.clientX;

          var moveLen = resize.left + (endX - startX);
          var maxT = box.clientWidth - resize.offsetWidth;
          if (moveLen < 248) moveLen = 248;
          if (moveLen > 600) moveLen = 600;
          if (moveLen > maxT - 150) moveLen = maxT - 150;

          resize.style.left = moveLen;
          left.style.width = moveLen + "px";
          right.style.width = box.clientWidth - moveLen - 5 + "px";
          pagination.style.width = box.clientWidth - moveLen + 5 + "px";
          if (box.clientWidth - moveLen - 5 < 1250) {
            _this.height = document.documentElement.clientHeight - 480;
            document.getElementsByClassName(
                "ant-pagination"
            )[0].style.marginRight = 0;
            document.getElementsByClassName(
                "ant-pagination-options"
            )[0].style.display = "none";
          } else {
            document.getElementsByClassName(
                "ant-pagination"
            )[0].style.marginRight = "124px";
            document.getElementsByClassName(
                "ant-pagination-options"
            )[0].style.display = "block";
            _this.height = document.documentElement.clientHeight - 460;
          }
          if (box.clientWidth - moveLen - 5 < 720) {
            _this.isShowBtn = true;
            _this.height = document.documentElement.clientHeight - 580;
          } else {
            _this.isShowBtn = false;
          }
        };
        document.onmouseup = function (evt) {
          document.onmousemove = null;
          document.onmouseup = null;
          resize.releaseCapture && resize.releaseCapture();
        };
        resize.setCapture && resize.setCapture();
        return false;
      };
    },
    searchTwo() {
      this.pagination.current = 1;
      this.formData.current = 1;
      this.getListPage();
    },
    deleteFnOrg() {
      this.deleteShowTwo = true;
      deleteFn({ id: this.orgItem.id }).then((res) => {
        if (res.code == 0) {
          this.getOrganTree();
          this.dialogVisibleOrg = false;
          this.deleteShowTwo = false;
          message.success(res.msg);
        }
      });
    },
    expandHandle() {
      console.log(this.$refs.tree.store);
      this.expandAll = !this.expandAll;
      this.expandNodes(this.$refs.tree.store.root);
    },
    // 遍历树形数据，设置每一项的expanded属性，实现展开收起
    expandNodes(node) {
      node.expanded = this.expandAll;
      for (let i = 0; i < node.childNodes.length; i++) {
        node.childNodes[i].expanded = this.expandAll;
        if (node.childNodes[i].childNodes.length > 0) {
          this.expandNodes(node.childNodes[i]);
        }
      }
    },
    onChange(e) {
      this.switchOpen = e;
      this.formData.childrenType = e?1:2
      this.getListPage();
    },
    closeTwo() {
      this.visibleTwo = false;
      this.getListPage();
    },
    closeTwoAddTwo() {
      this.visibleTwo = false;
    },
    closeTwoAdd() {
      this.visible = false;
    },
    open(item) {
      this.dialogVisibleTwo = true;
      this.deleteItem = item;
    },
    addNodeFn(id, organizationName) {
      this.item = JSON.parse(JSON.stringify({}));
      this.itemAdd = { id, organizationName };
      this.visible = true;
    },
    updateNodeFn(node) {
      this.item = node;
      this.itemAdd = {};
      this.item.organizationName = node.label;
      this.item = JSON.parse(JSON.stringify(this.item));
      this.visible = true;
    },
    deleteNode(node) {
      this.dialogVisibleOrg = true;
      this.orgItem = node;
    },
    editUser(item) {
      this.itemTwo = JSON.parse(JSON.stringify(item));
      this.visibleTwo = true;
    },
    addAdminFn() {
      this.itemTwo = {};
      this.addUserDataId = this.organization;
      this.visibleTwo = true;
    },
    close() {
      this.visible = false;
      this.getOrganTree();
    },
    changeType(type) {
      if (type == 3) {
        selectSiteListByOrgId({
          id: this.organization,
        }).then((res) => {
          if (res.code == 0) {
            if (res.data.length == 0) {
              message.error("请选择站点");
              return;
            }
          }
        });
      }
      this.type = type;
      if (this.type == 1) {
        let _this = this;
        this.$nextTick(() => {
          var left = document.getElementById("left");
          var box = document.getElementById("box");
          var right = document.getElementById("right");
          var pagination = document.getElementById("pagination");
          left.style.width = 348 + "px";
          right.style.width = box.clientWidth - 348 - 5 + "px";
          pagination.style.width = box.clientWidth - 348 + 5 + "px";
          if (box.clientWidth - 250 - 5 < 1250) {
            this.height = document.documentElement.clientHeight - 480;
            document.getElementsByClassName(
                "ant-pagination"
            )[0].style.marginRight = 0;
            document.getElementsByClassName(
                "ant-pagination-options"
            )[0].style.display = "none";
          } else {
            document.getElementsByClassName(
                "ant-pagination"
            )[0].style.marginRight = "124px";
            document.getElementsByClassName(
                "ant-pagination-options"
            )[0].style.display = "block";
            this.height = document.documentElement.clientHeight - 460;
          }
          if (box.clientWidth - 250 - 5 < 720) {
            _this.isShowBtn = true;
            _this.height = document.documentElement.clientHeight - 580;
          } else {
            _this.isShowBtn = false;
          }
          this.getLeftMove();
        });
        this.getListPage();
      }
    },
    onSelect(data) {
      this.organization = data.id;
      this.formData.orgId = data.id;
      this.pagination.current = 1;
      this.formData.current = 1;
      if (this.type == 1) {
        this.getListPage();
      }
    },
    // nodeExpand(data) {
    //   this.defaultShowNodes.push(data.id);
    // },
    // nodeCollapse(data) {
    //   for (let index = 0; index < this.defaultShowNodes.length; index++) {
    //     const element = this.defaultShowNodes[index];
    //     if (element == data.id) {
    //       this.defaultShowNodes.splice(index, 1);
    //     }
    //   }
    // },
    deleteFnTwo() {
      this.deleteShow = true;
      deleteOne({ id: this.deleteItem.id }).then((res) => {
        if (res.code == 0) {
          this.dialogVisibleTwo = false;
          this.deleteShow = false;
          this.getListPage();
        }
      });
    },
    search() {
      this.getOrganTree();
    },
    // 切换 搜索
    selectFn(value) {
      this.selectValue = value;
    },
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.formData.current = current;
      this.getListPage();
    },
    handleTableChange(page, pageSize) {
      this.pagination.current = 1;
      this.pagination.pageSize = pageSize;
      this.formData.current = 1;
      this.formData.size = pageSize;
      this.getListPage();
    },
    //授权列表数据
    getListPage() {
      this.loading = true;
      list(this.formData).then((res) => {
        if(res.data&&res.data.records.length>0) {
          this.dataSource = res.data.records;
        }else{
          this.dataSource = [];
        }
        this.pagination.current = res.data.current;
        this.formData.current = res.data.current;
        this.pagination.total = res.data.total;
        this.height = 0;
        if (this.pagination.total > 0) {
          this.heightLeft = `${document.documentElement.clientHeight - 285}px`;
          var box = document.getElementById("box");
          if((box.clientWidth - 250 - 5) < 1250){
            this.height = document.documentElement.clientHeight - 480;
            console.log(this.height,'sadasd')
          }else{
            this.height = document.documentElement.clientHeight - 460;
          }
          window.onresize = () => {
            return (() => {
              this.height = document.documentElement.clientHeight - 460;
              this.heightLeft = `${
                  document.documentElement.clientHeight - 285
              }px`;
              var left = document.getElementById("left");
              var box = document.getElementById("box");
              var right = document.getElementById("right");
              var pagination = document.getElementById("pagination");
              if(!left){
                return;
              }
              left.style.width = 348 + "px";
              right.style.width = box.clientWidth - 348 - 5 + "px";
              pagination.style.width = box.clientWidth - 348 + 5 + "px";
              if (box.clientWidth - 250 - 5 < 1250) {
                this.height = document.documentElement.clientHeight - 480;
                document.getElementsByClassName(
                    "ant-pagination"
                )[0].style.marginRight = 0;
                document.getElementsByClassName(
                    "ant-pagination-options"
                )[0].style.display = "none";
              } else {
                this.height = document.documentElement.clientHeight - 460;
                document.getElementsByClassName(
                    "ant-pagination"
                )[0].style.marginRight = "124px";
                document.getElementsByClassName(
                    "ant-pagination-options"
                )[0].style.display = "block";
              }
              if (box.clientWidth - 250 - 5 < 720) {
                this.height = document.documentElement.clientHeight - 580;
                this.isShowBtn = true;
              } else {
                this.isShowBtn = false;
              }
            })();
          };
        }
        this.loading = false;
      });
      orgReportsCount(this.formData).then(res=>{
        if(res.code===0) {
          if(res.data) {
            this.countNum = res.data;
          }else{
            this.countNum = {}
          }
        }
      })
    },
    getOrganTree() {
      const _this = this;
      this.isTree = true;
      organTree({ name: _this.organizationName }).then((res) => {
        if (res.code == 0) {
          if (res.data.length > 0) {
            this.formData.orgId = res.data[0].id;
          }
          if (this.type == 1) {
            this.getListPage();
          }
          let options = JSON.stringify(res.data)
              .replace(/organizationName/g, "label")
              .replace(/id/g, "id");
          this.$nextTick(() => {
            _this.treeData = JSON.parse(options);
            _this.listData = JSON.parse(options);
          });
        }
        this.isTree = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .el-date-editor .el-range-input{
  background: transparent;
}
.box {
  display: flex;
  width: 100%;
  height: 80vh;
  position: relative;
  .left {
    font-size: 14px;
    color: #000;
    padding: 0 24px 24px;
    width: 348px;
    height: calc(107.5% - 3px);
    border-right: solid 1px #E4E7ED;
    .title {
      margin-bottom: 24px;
    }
    .search {
      margin-bottom: 12px;
    }
    /deep/ .ant-btn-primary {
      background: #1890ff;
      padding: 0 5px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #415058;
    }
    /deep/ .ant-input {
      background: #f7f7f7;
    }
  }
  .right {
    flex: 1;
    height: 100%;
    //width: 100%;
    font-size: 14px;
    //padding-top: 24px;
    width: 500px;
    .right-name {
      padding-left: 24px;
      color: #000;
    }
    .log-box {
      //border-bottom: solid 1px #dcdfe6;
      //display: flex;
      margin-left: 24px;
      margin-right: 24px;
      margin-top: 25px;
      // .log {
      //   padding: 10px 20px;
      //   border-top: solid 1px #dcdfe6;
      //   border-left: solid 1px #dcdfe6;
      //   cursor: pointer;
      //   border-bottom: solid 1px #dcdfe6;
      //   background: #F5F7FA;
      // }
      // .log:last-child {
      //   border-right: solid 1px #dcdfe6;

      // }
      // .log:first-child {

      // }
    }
    .search {
      display: flex;
      margin-bottom: 20px;
      flex-wrap: wrap;
      /deep/ .ant-input-group {
        width: auto;
      }
      /deep/ .ant-select-selection {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .ant-input {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ .el-input__inner {
        background-color: rgba(245, 247, 250, 1);
        height: 40px;
      }
      /deep/ input::-webkit-input-placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__placeholder {
        color: rgba(102, 111, 128, 1);
      }
      /deep/ .ant-select-selection__rendered {
        line-height: 39px;
      }
      /deep/ .el-select__tags {
        white-space: nowrap;
        overflow: hidden;
      }
      /deep/ .el-select__tags {
        flex-wrap: nowrap;
      }
    }

    /deep/ .ant-table-wrapper {
      // width: 100%;
    }
  }
}
.top {
  padding: 24px;
  padding-bottom: 0px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .fraction{
    width: 300px;
    margin-left: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-weight: bold;
    >p{
      margin-bottom: 0;
      display: flex;
      align-items: center;
      font-size: 14px;
      >span{
        font-size: 17px;
        margin-left: 5px;
      }
    }
  }
  .search {
    display: flex;
  }

  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
.el-tree {
  overflow-y: auto;
}
.dir {
  height: 1px;
  background: #dcdfe6;
  margin-left: 24px;
  margin-right: 24px;
  margin-top: -1px;
}
.middle {
  //height: calc(113% - 4px);
  width: 1px;
  background: #f4f4f6;
}
.tr-one {
  display: flex;
}
.quan {
  width: 24px;
  height: 24px;
  background: #fff;
  border: solid 1px #ccc;
  border-radius: 50%;
}
.close-name {
  color: #303133;
  font-weight: 400;
  margin-top: 4px;
}
.close-img {
  margin-top: -1px;
  margin-right: 4px;
  cursor: pointer;
}
.Status1 {
  color: #67c23a;
}
.Status2 {
  color: #f56c6c;
}
.btn {
  margin-top: 24px;
  text-align: right;
}
/deep/ .ant-pagination-options {
  float: left;
  margin-right: 6px;
}
/deep/ .ant-pagination-total-text {
  float: left;
}
/deep/ .ant-pagination-options-quick-jumper {
  position: absolute;
  right: 20px;
}
/deep/ .ant-pagination {
  margin-right: 124px;
}
.pagination {
  display: flex;
  padding: 12px;
  padding-right: 0px;
  flex-direction: column;
  align-items: flex-end;
  border-top: solid #E4E7ED 1px;
  position: absolute;
  bottom: 0;
  padding-right: 24px;
  width: calc(100% - 627px);
  margin-left: -5px;
}
/deep/ .ant-pagination-item-active {
  background: #1890ff;
}
/deep/ .ant-pagination-item-active a {
  color: #fff;
}
.overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  width: 150px;
}
.dian {
  width: 3px;
  height: 3px;
  border: 1px solid #303133;
  border-radius: 100px;
  background-color: #303133;
  display: block;
  margin-bottom: 1px;
  margin-top: 1px;
}
.dian-box {
  margin-top: 3px;
  padding-left: 20px;
  margin-right: 10px;
  text-align: center;
  position: relative;
  .icon-txt {
    font-weight: bold;
    color: #000;
    font-size: 16px;
    position: absolute;
    top: -10px;
    right: -10px;
    bottom: -10px;
    left: -20px;
  }
}
/deep/ .custom-tree-node {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}
/* 树形结构节点添加连线 */
.tree /deep/ .el-tree-node {
  position: relative;
  padding-left: 16px;
}

.tree /deep/ .el-tree-node__children {
  padding-left: 16px;
}

.tree /deep/ .el-tree-node :last-child:before {
  height: 38px;
}

.tree /deep/ .el-tree > .el-tree-node:before {
  border-left: none;
}

.tree-container /deep/ .el-tree > .el-tree-node:after {
  border-top: none;
}

.tree /deep/ .el-tree-node:before {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}

.tree /deep/ .el-tree-node:after {
  content: "";
  left: -4px;
  position: absolute;
  right: auto;
  border-width: 1px;
}
.tree /deep/ .el-tree-node__expand-icon.is-leaf {
  display: none;
}

.tree /deep/ .el-tree-node:before {
  border-left: 1px dashed #b8b9bb;
  bottom: 0px;
  height: 100%;
  top: -26px;
  width: 1px;
}

.tree /deep/ .el-tree-node:after {
  border-top: 1px dashed #b8b9bb;
  height: 20px;
  top: 12px;
  width: 24px;
}

.tree-box {
  margin-left: -15px;
  /deep/ .el-tree-node__content {
    padding-left: 0px !important;
  }
  .tree-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    //width: 154px;
  }

  /deep/ .icon-tree {
    position: relative;
    width: 26px;
    height: 24px;
    background: url("../../../assets/images/open.jpg");
    background-size: 100% 100%;
  }
  /deep/ .expanded {
    background: url("../../../assets/images/close.jpg");
    background-size: 100% 100%;
    width: 27px;
    height: 24px;
  }
  /deep/ .is-leaf {
    background-image: none;
    background-size: 100% 100%;
  }
  /deep/ .el-tree-node__expand-icon {
    transform: initial;
    transition: auto;
  }
}
/deep/ .ant-dropdown-menu-item {
  padding: 3px 20px;
}
/deep/ .el-icon-caret-right:before {
  //font-size: 16px;
}
.switch {
  position: absolute;
  left: 12px;
  display: flex;
  align-items: center;
}
.cy-txt {
  color: rgba(102, 111, 128, 1);
  font-size: 14px;
  font-family: HarmonyOS_Sans_SC-regular;
  margin-left: 10px;
}
/deep/ .table {
  margin-bottom: 20px;
}
/deep/ .ant-spin-nested-loading {
  width: 100%;
}
.btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}
/deep/ .el-tabs__header {
  margin: 0px;
}
#resize {
  width: 5px;
  cursor: w-resize;
  float: left;
}
/deep/ .table {
  margin-top: 0px;
}
</style>